import { InfoTooltip } from '../InfoTooltip/index.js'

import styles from './DataItem.module.scss'

/**
 * DataItem — a single label + value pair.
 *
 * A typographic atom for data display. Renders a small label above a
 * prominent value. Used as a building block for DataGrid.
 *
 * Typography scale is controlled by CSS custom properties inherited from an
 * ancestor (typically set by DataGrid via its `size` prop):
 *   --bim-data-label-size  (default: 0.875em)
 *   --bim-data-value-size  (default: 1.2em)
 *
 * @param {object}           props
 * @param {string}           props.label    - Descriptive label (e.g. "Floor", "Rooms")
 * @param {React.ReactNode}  props.value    - Data value; accepts string, number, or JSX
 * @param {string}          [props.tooltip] - Optional plain-text hint shown as a (?) icon
 */
export function DataItem({ label, value, tooltip }) {
  return (
    <div className={styles.root}>
      {label && (
        <span className={styles.labelRow}>
          {/* `title` to expose the full label as a native browser tooltip when CSS
              ellipsis truncates it. */}
          <span className={styles.label} title={typeof label === 'string' ? label : undefined}>
            {label}
          </span>
          {tooltip && <InfoTooltip text={tooltip} />}
        </span>
      )}
      <span className={styles.value}>{value}</span>
    </div>
  )
}
